import React, {Fragment} from 'react';
import {useParams} from "react-router-dom";

import './HistoryPageBody.scss';
import PageBodyWrapper from "root/PageBodyWrapper";
import DocumentsContainer from "root/DocumentsContainer";

const DocumentsPageBody = (props) =>
{
    let { provider_id } = useParams();

    return (
        <Fragment>
            <PageBodyWrapper title='Documents'>
            <div className='table-section-rows'>
                <DocumentsContainer provider_id={encodeURIComponent(provider_id)} />
            </div>
            </PageBodyWrapper>
        </Fragment>
    )
}

export default DocumentsPageBody;
